import libEn from './EN.js'
import libEs from './ES.js'

export const en = libEn
export const es = libEs